import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  ButtonNewRecord,
  FlexRow,
  TableEditButtons,
  toastFailure,
  usePaginatedQueryV8,
} from 'motion-components';
import { Card } from 'react-bootstrap';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues, Filters } from './filters';
import { DataGrid } from './grid';
import { handleExport } from './export-columns';
import { useApolloClient } from '@apollo/client';
import { getRouteByName } from 'app/routes';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserLocationPermissions } from 'shared-pages/hooks';
import { isAfisCyprus, regionsTitle } from 'shared-pages/common/constants';

/* ----------------------------------------------------------- */
/* ------------------------ Page ----------------------------- */
export const NomoiGridPage = () => {
  const { appStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('NomoiGridPage');

  const location = useLocation<any>();
  const history = useHistory();
  const [selected, setSelected] = useState<any>(null);
  const { t } = useTranslation();

  const { canView, canAddNew, canEdit, canDelete } = useUserLocationPermissions();

  const handleAddNew = () => {};
  /* ------------------- Query ------------------------------- */
  const initOrderBy = 'name ASC';
  const query = usePaginatedQueryV8(
    gqlGetQuery,
    buildWhereFromFilterValues,
    location.state?.order ?? initOrderBy,
    appStore,
    true,
    //{ isActive: true },
  );
  const {
    loading,
    data,
    dataCount,
    error,
    initPageIndex,
    filtersChanged,
    gridPageChanged,
    queryState,
    queryParams,
    setQueryParams,
    refetch,
  } = query;

  const client = useApolloClient();

  const canCreateNew = true;
  const handleCreateNew = useCallback(() => {
    history.push({
      pathname: generatePath(getRouteByName('Nomos'), { id: -1 }),
      state: {
        pathname: location.pathname,
        ...location.state,
      },
    });
  }, [history, location.pathname, location.state]);

  const gridRef = useRef();

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  } else {
    return (
      <Card className="shadow">
        <Card.Header>
          <FlexRow>
            <Card.Title className="m-0">{t('Νομοί')}</Card.Title>
            {/* Table Edit Buttons  */}
            {/* <TableEditButtons
              className="me-3"
              canEdit={true}
              canInsert={canAddNew}
              canDelete={true}
              tableOptionsMeta={() => {
                if (gridRef.current) return (gridRef.current as any).table.options.meta;
                else return undefined;
              }}
              twoLines={false}
            /> */}
          </FlexRow>
        </Card.Header>
        <Card.Body className="nopadding">
          {/* Φίλτρα */}
          <Filters onChange={filtersChanged} initialValues={queryState?.filterValues ?? {}} />
          {/* Grid */}
          <DataGrid
            ref={gridRef}
            loading={loading}
            data={data}
            refetch={refetch}
            dataCount={dataCount}
            initPageIndex={initPageIndex}
            onPageChange={gridPageChanged}
            handleExport={() => {
              handleExport(client, queryState, t);
            }}
            initOrderBy={queryParams?.order ?? initOrderBy}
            onOrderChange={(orderBy) => {
              const newQueryParams = { ...queryParams, order: orderBy };
              setQueryParams(newQueryParams);
              history.replace({
                pathname: location.pathname,
                state: {
                  ...location.state,
                  order: orderBy,
                },
              });
            }}
            selected={selected}
            setSelected={setSelected}
          />
        </Card.Body>
      </Card>
    );
  }
};
